module.exports = __webpack_public_path__ + "img/Tyme Bank.8e10962e.svg";